import { ChangeDetectionStrategy, Component, EventEmitter, Input, Output } from '@angular/core';

import { PortalAncillaryBundle } from '@app/services/api/api.types';

@Component({
  selector: 'ancillaries-bundle-modal',
  templateUrl: './ancillaries-bundle-modal.component.html',
  styleUrl: './ancillaries-bundle-modal.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class AncillariesBundleModalComponent {
  @Input() ancillaryBundle?: PortalAncillaryBundle;

  @Output() hideModal = new EventEmitter();
  @Output() ancillariesBundleContinue = new EventEmitter();
  @Output() ancillariesBundleNext = new EventEmitter();

  sections = [
    {
      title: 'Without protection, you may need to:',
      items: [
        {
          icon: 'travel_orange',
          label: 'Handle everything on your own',
          details: 'Calls, changes, rebooking, coordination',
        },
        {
          icon: 'travel_orange',
          label: 'Pay for new flights yourself',
          details: 'If your flight is delayed or canceled',
        },
        {
          icon: 'plane_orange',
          label: 'Lose most of your ticket value',
          details: 'If you need to cancel your trip',
        },
        {
          icon: 'travel_orange',
          label: 'Wait weeks for refunds',
          details: 'Depending on airline policies',
        },
      ],
    },
    {
      title: 'Add full protection to:',
      items: [
        {
          icon: 'travel_green',
          label: 'Cancel your trip and get your money back',
        },
        {
          icon: 'travel_i_green',
          label: 'Get rebooked if your flight is disrupted',
        },
        {
          icon: 'support',
          label: 'Avoid unexpected costs',
        },
        {
          icon: 'support',
          label: 'Get help 24/7',
        },
      ],
    },
  ];
}
